import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
@Injectable()
export class FilterPipe implements PipeTransform {
  transform(items: any[],key :string, filter: Object,key1:string,filter1:Object): any {
    if (!items || !(filter || filter1)) {
      return items;
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter(item => {
      if (filter && filter1){
        return item[key] === filter && item.country === filter1;
      }else {
        if (filter)
          return item[key] === filter;
        if (filter1)
          return item[key1] === filter1;
      }
    });
  }
}
